import { render, staticRenderFns } from "./EmptyRolesIcon.vue?vue&type=template&id=b6f5a032"
import script from "./EmptyRolesIcon.vue?vue&type=script&lang=js"
export * from "./EmptyRolesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports